export default "/images/60714a1b778e4b44371804f3e4ee7e79.avif";